import { render, staticRenderFns } from "./ForTeachers.vue?vue&type=template&id=660f09cb&"
import script from "./ForTeachers.vue?vue&type=script&lang=js&"
export * from "./ForTeachers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports